import { TBody } from '../../../components/common/table/TBody/TBody';
import { Table } from '../../../components/common/table/Table/Table';
import { EventListHeader } from './listHeader/EventListHeader';
import { EventListRow } from './listRow/EventListRow';
import './EventList.scss';

export interface EventListProps {
  eventList: any[];
  onEventClick: (eventId: string) => void;
}

export function EventList({ eventList, onEventClick }: EventListProps) {
  return (
    <div className="event-list">
      <Table>
        <EventListHeader />
        <TBody className="event-list-table-body">
          {eventList.map((listItem, index) => (
            <EventListRow
              _id={listItem._id}
              index={index}
              patient_id={listItem?.patient_id}
              createdDateTime={listItem?.timestamp}
              plan_name={listItem?.plan_name}
              station={listItem?.station}
              machine={listItem?.machine}
              status={listItem?.status}
              onDetailsClick={onEventClick}
              key={`event-row-${index}-${listItem?._id}`}
            />
          ))}
        </TBody>
      </Table>
    </div>
  );
}
